import type { CSSProperties } from "react";
import type { StorefrontConfig, ThemeId } from "../types/storefront";

interface ThemePreset {
  id: ThemeId;
  label: string;
  background: string;
  surface: string;
  text: string;
  muted: string;
  radius: string;
}

export const themes: Record<ThemeId, ThemePreset> = {
  "modern-retail": {
    id: "modern-retail",
    label: "Modern Retail",
    background: "#f7f9fc",
    surface: "#ffffff",
    text: "#10233f",
    muted: "#607089",
    radius: "8px"
  },
  "premium-minimal": {
    id: "premium-minimal",
    label: "Premium Minimal",
    background: "#fafafa",
    surface: "#ffffff",
    text: "#18181b",
    muted: "#71717a",
    radius: "4px"
  },
  "fresh-market": {
    id: "fresh-market",
    label: "Fresh Market",
    background: "#f5faf5",
    surface: "#ffffff",
    text: "#16301f",
    muted: "#5d7163",
    radius: "8px"
  },
  "bakery-cafe": {
    id: "bakery-cafe",
    label: "Bakery & Cafe",
    background: "#fffaf6",
    surface: "#ffffff",
    text: "#30231f",
    muted: "#75645f",
    radius: "8px"
  }
};

export function getThemeStyle(store: StorefrontConfig, previewTheme?: ThemeId): CSSProperties {
  const theme = themes[previewTheme ?? store.themeId];
  return {
    "--store-primary": store.primaryColor,
    "--store-secondary": store.secondaryColor,
    "--store-accent": store.accentColor ?? store.secondaryColor,
    "--store-background": theme.background,
    "--store-surface": theme.surface,
    "--store-text": theme.text,
    "--store-muted": theme.muted,
    "--store-radius": theme.radius
  } as CSSProperties;
}
